import { useEffect, useRef } from 'react'
import { gsap } from "gsap";
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin";
import {motion} from 'framer-motion'
import LogoS from '../../../assets/images/logo-s.png'
import Mtns from '../../../assets/images/mtns.JPG'
import './index.scss'

const Logo = () => {
  const bgRef = useRef()
  const outlineLogoRef = useRef()
  const solidLogoRef = useRef()
  const image = document.getElementsByClassName('solid-logo')
  const svg = document.getElementsByClassName('svg')
  const items = Array.from(image).concat(Array.from(svg));

  const pathVariants = {
    hidden: {
      pathLength: 0
    },
    visible: {
      pathLength: 1,
      transition: {
        duration: 10,
      }
    }
  }

  useEffect(() => {
    gsap.registerPlugin(DrawSVGPlugin);

    gsap
      .timeline()
      .to(bgRef.current, {
        duration: 1,
        opacity: 1,
      })
      .from(outlineLogoRef.current, {
        drawSVG: 0,
        duration: 20,
      })

    gsap.fromTo(
      solidLogoRef.current,
      {
        opacity: 0,
      },
      {
        opacity: 1,
        delay: 4,
        duration: 4,
      }
    )
  }, [])

  var input = {
    mouseX: {
        start: 0,
        end: window.innerWidth,
        current: 0,
    },
    mouseY:{
        start: 0,
        end: window.innerHeight,
        current: 0,
    }
}

input.mouseX.range = input.mouseX.end - input.mouseX.start;
input.mouseY.range = input.mouseY.end - input.mouseY.start;

var output = {
  x: {
      start: 0,
      end: 150,
      current: 0,
  },
  y:{
      start: 0,
      end: 150,
      current: 0,
  },
  z:{
      range: 10000
  },
  scale:{
      start: 1,
      end: 0.2
  },
  blur:{
      startingDepth: .1,
      range: 10
  }
}


output.scale.range = output.scale.end - output.scale.start
output.x.range = output.x.end - output.x.start
output.y.range = output.y.end - output.y.start

var mouse = {
  x: window.innerWidth * .5,
  y: window.innerHeight * .5
}

function updateInputs(){
  // mouse x input
  input.mouseX.current = mouse.x;
  input.mouseX.fraction = (input.mouseX.current - input.mouseX.start) / input.mouseX.range;
  // mouse y input
  input.mouseY.current = mouse.y;
  input.mouseY.fraction = (input.mouseY.current - input.mouseY.start) / input.mouseY.range;
}

function updateOutputs(){
  output.x.current = output.x.start + (input.mouseX.fraction * output.x.range)

  output.y.current = output.y.start + (input.mouseY.fraction * output.y.range)
}

  function updateEachParallaxItem(){
    items.forEach(function(item, i){
      let depth = parseFloat(item.dataset.depth, 10);
      var itemOutput = {
        x: output.x.current - (output.x.current * depth),
        y: output.y.current - (output.y.current * depth),
        zIndex: output.z.range - (output.z.range * depth),
        zIndexSVG: (output.z.range * depth),
        scale: output.scale.start + (output.scale.range * depth),
        blur: (depth - output.blur.startingDepth) * output.blur.range
    };
      item.style.transform = `translate(${itemOutput.x}px, ${itemOutput.y}px)`
      item.style.zIndexSVG  = itemOutput.zIndex;
      if (i === 1){
        item.style.zIndex = itemOutput.zIndex;
        item.style.transform = `scale(7) translate(${itemOutput.x}px, ${itemOutput.y}px)`
      }
    })
  }

  function handleMouseMove(e){
    mouse.x = e.clientX;
    mouse.y = e.clientY;

    updateInputs();
    updateOutputs();
    updateEachParallaxItem();
  }

  function handleResize(){
    input.mouseX.end = window.innerWidth;
    input.mouseX.range = input.mouseX.end - input.mouseX.start;

    input.mouseY.end = window.innerHeight;
    input.mouseY.range = input.mouseY.end - input.mouseY.start;
}

  window.addEventListener('mousemove', handleMouseMove)


  return (
    <div className="logo-container" ref={bgRef}>
      <img className="solid-logo" data-depth='0.1' ref={solidLogoRef} src={Mtns} alt="JavaScript,  Developer"/>
      <svg
        data-depth='0.9'
        className='svg'
        width="559pt"
        height="1030pt"
        version="1.0"
        viewBox="0 0 559 897"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g
          className="svg-container"
          transform="translate(50 300)"
          fill="none"
        >
          <motion.path
            d="M 215 180 L 215 115 A 1 1 0 0 0 128 113 L 128 180 L 215 180"  // Replace with the desired path data
            className='path'
            stroke="black"
            stroke-width="1" 
            variants={pathVariants}
            initial="hidden"
            animate="visible"
          />
        </g>
      </svg>
    </div>
  )
}

export default Logo